/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
const { LTVS } = require('./config/ltvs');
const { primeRates, primeRatesCtMandCkDirect } = require('./config/prime-rates');
const {
    WARRANTY_PRICES, LENDERS_FUNDING_WARRANTY, LENDERS_NO_WARRANTY,
    PAINT_PRICES, LENDERS_FUNDING_PAINT, LENDERS_NO_PAINT,
    COSMETIC_REPAIR_PRICES, LENDERS_FUNDING_COSMETIC_REPAIR, LENDERS_NO_COSMETIC_REPAIR,
    LENDERS_NO_WARRANTY_PCP,
    LENDERS_FUNDING_WARRANTY_PCP,
    LENDERS_FUNDING_PAINT_PCP,
    LENDERS_NO_PAINT_PCP,
    LENDERS_FUNDING_COSMETIC_REPAIR_PCP,
    LENDERS_NO_COSMETIC_REPAIR_PCP,
} = require('./config/products');
const {
    MONEYBARN, M247, OODLE, MARSH, MONEYWAY, ADVANTAGE, SMF, STARTLINE,
    LENDABLE, CARFINANCE247, ALPHERA, METROBANK, BNP, MANNISLAND, MOTONOVO,
    V12, BLUE, BILLING, RATESETTER, CLOSE, AUTOMONEY, TANDEM, ZOPA,
    CREDITAGRICOLE, NORTHRIDGEFINANCE, CAMCO
} = require('./constants/lenders');
const { VEHICLE_TYPE_ENUM } = require('./enum/vehicle-type');
const { PRODUCT_TYPE_ENUM } = require('./enum/product-type');
const { VEHICLE_CONDITION_ENUM } = require('./enum/vehicle-condition');

const dateLib = require('./datetime');
const { mockAlpheraProposal, mockBnpProposal, mockCloseProposal, mockZopaProposal } = require('./mocks');

const ProposalHelper = require('./utility/proposal-helper');

const CTM = 42416;
const CkDirectAffiliateId = 21746;
const CarcraftAffiliateId = 2655;
const PistonheadsAffiliateId = 43118;
const CargurusAffiliateId = 21617;

// Determine the Loan To Value maximum lend for a given lender
function getMaxLTV(
    ltvPrice,
    lender,
    tierId,
    productType = PRODUCT_TYPE_ENUM.HP,
    vehicleCondition = VEHICLE_CONDITION_ENUM.USED,
    vehicleType = VEHICLE_TYPE_ENUM.CAR
) {
    let ltv = 1.25;
    let buffer = 0;

    const ltvObj = LTVS.find(l => l.financeCompanyId === lender);

    if (!ltvObj) {
        return ltvPrice * ltv;
    }

    const tierObj = tierId && ltvObj.tiers ?
        ltvObj.tiers.find(t => t.tierId === tierId) : null;

    /**
     * Eric note - once LTVs are moved to the proposal and quotes api returns the LTV object
     * appropriate to the prop tier, we can remove this first part
     */
    if (tierObj) {
        if (tierObj.complex) {
            const productBand = tierObj.complex[productType] ? tierObj.complex[productType] : tierObj.complex[0];
            const conditionBand = productBand[vehicleCondition] ? productBand[vehicleCondition] : productBand[0];
            const typeBand = conditionBand[vehicleType] ? conditionBand[vehicleType] : conditionBand[0];

            if (typeBand.length > 0) {
                const ltvBand = typeBand.reduce((p, c) => {
                    return ltvPrice > c.limit ? c : p;
                }, null);
                ltv = ltvBand.simple;
                buffer = ltvBand.buffer;
            }
            else {
                ltv = tierObj.simple;
                buffer = tierObj.buffer ? tierObj.buffer : 0;
            }
        }
        else {
            ltv = tierObj.simple;
            buffer = tierObj.buffer ? tierObj.buffer : 0;
        }
    }
    else if (ltvObj.complex) {
        const productBand = ltvObj.complex[productType] ? ltvObj.complex[productType] : ltvObj.complex[0];
        const conditionBand = productBand[vehicleCondition] ? productBand[vehicleCondition] : productBand[0];
        const typeBand = conditionBand[vehicleType] ? conditionBand[vehicleType] : conditionBand[0];

        if (typeBand.length > 0) {
            const ltvBand = typeBand.reduce((p, c) => {
                return ltvPrice > c.limit ? c : p;
            }, null);
            ltv = ltvBand.simple;
            buffer = ltvBand.buffer ? ltvBand.buffer : 0;
        }
        else {
            ltv = tierObj.simple;
            buffer = tierObj.buffer ? tierObj.buffer : 0;
        }
    }
    else {
        ltv = ltvObj.simple;
        buffer = ltvObj.buffer ? ltvObj.buffer : 0;
    }

    // Some make it 90 but that's the lowest
    if (ltv < 0.90) {
        ltv = 0.90;
    }

    const maxLend = (ltv * ltvPrice) + buffer;

    return maxLend;
};

const LTV_BASELINES = [
    {
        name: 'Glasses Retail',
        id: 0,
        financeCompanies: [
            MONEYBARN, OODLE, MONEYWAY, ADVANTAGE, STARTLINE,
            LENDABLE, METROBANK, BLUE, AUTOMONEY, TANDEM
        ]
    },
    {
        name: 'Glasses Transacted',
        id: 1,
        financeCompanies: [
            SMF
        ]
    },
    {
        name: 'Glasses Trade',
        id: 2,
        financeCompanies: [

        ]
    },
    {
        name: 'CAP Retail',
        id: 3,
        financeCompanies: [
            MOTONOVO, BNP, V12, MANNISLAND, CLOSE,
            NORTHRIDGEFINANCE, BILLING, ZOPA
        ]
    },
    {
        name: 'CAP Clean',
        id: 4,
        financeCompanies: [
            ALPHERA, NORTHRIDGEFINANCE
        ]
    },
]

function getWarrantyPrice(loanAmount, options) {
    if (options.oldWarrantyPrice) {
        return WARRANTY_PRICES[0].price;
    }

    const p = WARRANTY_PRICES
        .filter(p => p.duration === (options.twoYearWarranty ? 2 : 1))
        .reduce((p, c) => {
            return loanAmount > c.limit ? c : p;
        }, null)

    return p ? p.price : 0;
};

function getPaintPrice(options) {
    return PAINT_PRICES.find(p => p === options.oldPaintPrice) || PAINT_PRICES[0];
}

function getCosmeticRepairPrice(options) {
    const cosmeticPrice = COSMETIC_REPAIR_PRICES.find(p => options.threeYearCosmeticRepair ? p.duration === 3 : p.duration === -1);
    return cosmeticPrice ? cosmeticPrice.price : 0;
}

/**
 * Function to return all extras values based on vehicle price, finance company acceptance and options
 * @param {number} vehiclePrice
 * @param {number} loanAmount
 * @param {number} financeCompanyId
 * @param {Object} options
 * @returns {Object}
 */
function getExtrasPricesForLender(vehicle, loanAmount, financeCompanyId, options) {
    const extrasPrice = {
        totalLoanAmount: loanAmount,
        totalLoanAmountPCP: loanAmount,
        warrantyPrice: 0,
        paintPrice: 0,
        extrasInPrice: 0,
        extrasInPricePCP: 0,
        extrasOutPrice: 0,
        extrasOutPricePCP: 0,
        extrasCashRequired: 0,
        extrasCashRequiredPCP: 0,
    }
    if (options.includesWarranty) {
        extrasPrice.warrantyPrice = getWarrantyPrice(vehicle.price, options);

        // HP
        if (LENDERS_FUNDING_WARRANTY.includes(financeCompanyId)) {
            // For lenders that fund warranty (including Zopa when doing HP)
            extrasPrice.extrasInPrice += extrasPrice.warrantyPrice;
        }
        else {
            if (LENDERS_NO_WARRANTY.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequired += extrasPrice.warrantyPrice;
            }
            else {
                extrasPrice.extrasOutPrice += extrasPrice.warrantyPrice;
            }
        }
        // PCP
        if (LENDERS_FUNDING_WARRANTY_PCP.includes(financeCompanyId)) {
            // For lenders that fund warranty (including Zopa when doing HP)
            extrasPrice.extrasInPricePCP += extrasPrice.warrantyPrice;
        }
        else {
            if (LENDERS_NO_WARRANTY_PCP.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequiredPCP += extrasPrice.warrantyPrice;
            }
            else {
                extrasPrice.extrasOutPricePCP += extrasPrice.warrantyPrice;
            }
        }
    }

    if (options.includesPaint) {
        extrasPrice.paintPrice = getPaintPrice(options);

        // HP
        if (LENDERS_FUNDING_PAINT.includes(financeCompanyId)) {
            extrasPrice.extrasInPrice += extrasPrice.paintPrice;
        } else {
            if (LENDERS_NO_PAINT.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequired += extrasPrice.paintPrice;
            }
            else {
                extrasPrice.extrasOutPrice += extrasPrice.paintPrice;
            }
        }
        // PCP
        if (LENDERS_FUNDING_PAINT_PCP.includes(financeCompanyId)) {
            extrasPrice.extrasInPricePCP += extrasPrice.paintPrice;
        } else {
            if (LENDERS_NO_PAINT_PCP.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequiredPCP += extrasPrice.paintPrice;
            }
            else {
                extrasPrice.extrasOutPricePCP += extrasPrice.paintPrice;
            }
        }
    }

    const vehicleAgeInYears = vehicleAgeInMonths(vehicle) / 12;

    if (options.includesCosmeticRepair && vehicleAgeInYears <= 7) {
        extrasPrice.cosmeticRepairPrice = getCosmeticRepairPrice(options);

        // HP
        if (LENDERS_FUNDING_COSMETIC_REPAIR.includes(financeCompanyId)) {
            extrasPrice.extrasInPrice += extrasPrice.cosmeticRepairPrice;
        } else {
            if (LENDERS_NO_COSMETIC_REPAIR.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequired += extrasPrice.cosmeticRepairPrice;
            } else {
                extrasPrice.extrasOutPrice += extrasPrice.cosmeticRepairPrice;
            }
        }
        // PCP
        if (LENDERS_FUNDING_COSMETIC_REPAIR_PCP.includes(financeCompanyId)) {
            extrasPrice.extrasInPricePCP += extrasPrice.cosmeticRepairPrice;
        } else {
            if (LENDERS_NO_COSMETIC_REPAIR_PCP.includes(financeCompanyId)) {
                extrasPrice.extrasCashRequiredPCP += extrasPrice.cosmeticRepairPrice;
            } else {
                extrasPrice.extrasOutPricePCP += extrasPrice.cosmeticRepairPrice;
            }
        }
    }

    extrasPrice.totalLoanAmount += extrasPrice.extrasInPrice;
    extrasPrice.totalLoanAmountPCP += extrasPrice.extrasInPricePCP;

    return extrasPrice
}

const GLASSES_EXCLUDED_LENDERS = [
    MOTONOVO, BNP, V12, MANNISLAND, ALPHERA, ZOPA, CREDITAGRICOLE, LENDABLE, MONEYWAY
];

const PCP_LENDERS = [
    ALPHERA, ZOPA, CLOSE, MOTONOVO, NORTHRIDGEFINANCE, CREDITAGRICOLE, V12, CARFINANCE247
];

function supportsPCP(id) {
    return PCP_LENDERS.includes(id);
};

const LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE = [
    TANDEM,
];

const LENDERS_NO_MONTHLY_PAYMENT_ROUNDING = [
    TANDEM,
]

const LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT = [
    LENDABLE,
    OODLE,
    MONEYWAY,
    TANDEM,
    ADVANTAGE,
    MOTONOVO,
    NORTHRIDGEFINANCE
];

const LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP = [
    MOTONOVO,
    CREDITAGRICOLE,
    V12
];

const LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT = [
    AUTOMONEY
];

const FLAT_RATE_CALC_ROUNDING = [
    { financeCompanyId: ADVANTAGE, dp: 2 },
    { financeCompanyId: AUTOMONEY, dp: 6 }
]

const LENDERS_TERM_ADJUST = [
    { financeCompanyId: MONEYBARN, adjust: 1, hp: true, pcp: true },
    { financeCompanyId: NORTHRIDGEFINANCE, adjust: 1, hp: false, pcp: true },
    { financeCompanyId: MOTONOVO, adjust: 1, hp: false, pcp: true },
]

const LENDERS_OTP_SPREAD_HP = [
    CREDITAGRICOLE,
    V12,
    NORTHRIDGEFINANCE
]

const LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT = [
    M247, //used as default lender for some tests
    LENDABLE,
    MOTONOVO,
    V12,
    CREDITAGRICOLE,
    NORTHRIDGEFINANCE,
    CARFINANCE247,
];

const LENDERS_TRUNCATE_MONTHLY_PAYMENT = [
    MONEYBARN,
];

function vehicleValid(prop, vehicle) {
    const compareStr = (s1, s2) => {
        // Treat null or undefined strings as empty
        s1 = isNullOrUndefined(s1) ? "" : s1;
        s2 = isNullOrUndefined(s2) ? "" : s2;

        return s1.trim().toLowerCase() === s2.trim().toLowerCase();
    };

    // Null or undefined Vehicle Type is treated as Unknown
    const propVehicleType = vehicle.vehicleType == null ? VEHICLE_TYPE_ENUM.UNKNOWN : vehicle.vehicleType;

    let isValid = true;

    if (prop.excludedVehicles) {
        for (const ev of prop.excludedVehicles) {
            if (
                (ev.make && compareStr(ev.make, vehicle.make)) &&
                (!ev.model || compareStr(ev.model, vehicle.model)) &&
                (!ev.derivative || compareStr(ev.derivative, vehicle.derivative)) &&
                (isNullOrUndefined(ev.vehicleType) || ev.vehicleType === VEHICLE_TYPE_ENUM.UNKNOWN || ev.vehicleType === propVehicleType)
            ) {
                isValid = false;
            }
        }
    }

    if (prop.supportedVehicleTypeIds && propVehicleType != VEHICLE_TYPE_ENUM.UNKNOWN) {
        if (!prop.supportedVehicleTypeIds.includes(propVehicleType)) {
            prop.vehicleRuleResults.push({
                id: prop.financeCompanyId,
                displayPriority: 1,
                vehicleId: vehicle.vehicleId,
                resultType: "VehicleFailRule",
                message: `Vehicle type ${Object.keys(VEHICLE_TYPE_ENUM).find(key => VEHICLE_TYPE_ENUM[key] === vehicle.vehicleType)} is excluded`,
            });
            return false;
        }
    }

    if (isValid)
        return true;

    // Vehicle is an Excluded Vehicle, so update Proposal
    prop.vehicleRuleResults.push({
        id: prop.financeCompanyId,
        displayPriority: 1,
        vehicleId: vehicle.vehicleId,
        resultType: "VehicleFailRule",
        message: "Vehicle is excluded",
    });

    return false;
};

function dealerValid(vehicle, proposal) {
    const did = vehicle.dealerId ? vehicle.dealerId :
        (vehicle.dealer && vehicle.dealer.dealerId) ? vehicle.dealer.dealerId : null

    if (!did || !proposal.bannedDealerIds || proposal.bannedDealerIds.length === 0) {
        return true;
    }

    const valid = proposal.bannedDealerIds.find(d => d === did) ? false : true

    if (!valid) {
        proposal.vehicleRuleResults.push({
            id: proposal.financeCompanyId,
            displayPriority: 1,
            vehicleId: vehicle.vehicleId,
            resultType: "VehicleFailRule",
            rule: "Dealer",
            message: "Dealer is banned with lender",
        })
    }

    return valid;
}

const base3year = 0.432;
const depreciationCurve = [
    0.144,
    0.1386,
    0.1494,
    0.1593,
    0.1512,
    0.162,
    0.1764,
    0.1845,
    0.1917,
    0.2079,
    0.2079,
    0.207,
    0.2025,
    0.015255,
    0.015516,
    0.015786,
    0.016074,
    0.016362,
    0.016668,
    0.016983,
    0.017307,
    0.017649,
    0.018,
    0.018369,
    0.018747,
    0.019152,
];

// https://www.themoneycalculator.com/vehicle-finance/calculators/car-depreciation-by-make-and-model/
const depreciationMakes = {
    'ABARTH': 25,
    'ALFA ROMEO': 55,
    'ARIEL': 5,
    'ASTON MARTIN': 35,
    'AUDI': 40,
    'AUSTIN': 100,
    'BENTLEY': 35,
    'BMW': 35,
    'BUGATTI': 45,
    'CADILLAC': 65,
    'CATERHAM': 20,
    'CHEVROLET': 55,
    'CHRYSLER': 50,
    'CITROEN': 45,
    'DACIA': 25,
    'DAEWOO': 40,
    'DAIHATSU': 55,
    'DODGE': 45,
    'DS AUTOMOBILES': 50,
    'FERRARI': 15,
    'FIAT': 40,
    'FORD': 40,
    'GREAT WALL': 50,
    'HONDA': 50,
    'HUMMER': 35,
    'HYUNDAI': 45,
    'INFINITI': 45,
    'ISUZU': 35,
    'JAGUAR': 50,
    'JEEP': 35,
    'KIA': 50,
    'LAMBORGHINI': 10,
    'LAND ROVER': 30,
    'LEXUS': 40,
    'LONDON TAXIS INTERNATIONAL': 65,
    'LOTUS': 20,
    'MASERATI': 45,
    'MAYBACH': 75,
    'MAZDA': 40,
    'MCLAREN': 25,
    'MERCEDES-BENZ': 40,
    'MG': 50,
    'MINI': 25,
    'MITSUBISHI': 40,
    'MORGAN': 40,
    'NISSAN': 35,
    'OPEL': 90,
    'PERODUA': 95,
    'PEUGEOT': 40,
    'PORSCHE': 25,
    'PROTON': 35,
    'RENAULT': 45,
    'ROLLS-ROYCE': 30,
    'ROVER': 55,
    'SAAB': 65,
    'SEAT': 60,
    'SKODA': 45,
    'SMART': 40,
    'SSANGYONG': 40,
    'SUBARU': 30,
    'SUZUKI': 25,
    'TESLA': 45,
    'TOYOTA': 35,
    'TVR': 35,
    'VAUXHALL': 40,
    'VOLKSWAGEN': 40,
    'VOLVO': 35,
    'WESTFIELD': 60,
};

// eslint-disable-next-line func-names
function calculateFutureValue(make, model, price, ageNow, termInMonths, pcpMileage = 8000) {
    // console.log('[Calculating Future Value]', make, model, price, ageNow, termInMonths, pcpMileage);
    let factor = 1.0;
    const ageInYears = Math.floor(ageNow);

    if (make) {
        make = make.toUpperCase();
    }

    // Do we have a make-specific override for the depreciation factor (3 year based)
    if (make in depreciationMakes) {
        // Scale factor
        // console.log("Make specific factor is", depreciationMakes[make]);
        factor = (1.0 - (depreciationMakes[make] / 100.0));
        // console.log('for this make, factor is', factor);
        // eslint-disable-next-line no-restricted-properties
        factor = Math.pow(factor, 1.0 / 3.0);
        // console.log('   cube root for this make, factor is', factor);
        factor = 1.0 - factor;
        // factor = 1.0 - Math.pow(depreciationMakes[make] / 100.0, 1.0/3.0);

        // so scale factor based on 3 year curve
        factor /= (base3year / 3.0);

        // cap
        // if( factor > 1.0) {
        //   factor = 1.0;
        // }

        // And cube root
        // eslint-disable-next-line no-restricted-properties
        factor = Math.pow(factor, 1.0 / 3.0);
    }

    // no partial years - so effect of 6 months not modelled (could interpolate)
    const termInYears = Math.floor(termInMonths / 12);
    const isHalfYear = (termInMonths === 54 || termInMonths === 42 || termInMonths === 30 || termInMonths === 18);

    // Ok, pretty simple, start with the current age of the car, and walk down the depreciation
    // curve until the termInYears is done.
    let futureValue = price;

    const MNF_FACTOR = 1.0; // MNF is 1.1 - revert back for higher residuals, as not writing as much there now

    try {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i <= termInYears; i++) {
            let index = ageInYears + i;

            // Hold at the last year if we've gone over (unlikely)
            if (index >= depreciationCurve.length) {
                index = depreciationCurve.length - 1;
            }

            let overallFactor = MNF_FACTOR * factor * depreciationCurve[index];

            // Workout the loss factor, then cap it sensibly.
            // if( factor < 1.0 && factor > 0.01 ) {
            //   overallFactor = factor;
            // }
            if (overallFactor > 0.5) {
                overallFactor = 0.5;
            }
            if (overallFactor < 0.0001) {
                overallFactor = 0.0001;
            }
            const deprec = (futureValue * overallFactor);
            // console.log("Future Value Calc", i, index, factor, overallFactor, depreciationCurve[index], futureValue, deprec, futureValue-deprec, price);

            futureValue -= deprec;
        }
    } catch (e) {
        // This isn't good I'd like to fallback
        // console.log('Error Calculating Depreciation', e);
        futureValue = price - (price * 0.15 * termInYears);
    }
    if (isHalfYear) {
        // Take 7.5% off
        futureValue -= (futureValue * 0.075);
    }

    // Now scale by mileage - benchmarked on BNP over a range of mileages
    // is just an adjustment factor.
    const mrate = -0.0000175;
    const mfac = pcpMileage - 11900;

    futureValue += mrate * mfac * futureValue;

    return futureValue;
};

const DEFAULT_TERM = 60;


// Prime Lender Matrix
const _fixedPrimeTemplate = {
    maxVehicleAgeAtEnd: 12,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: 8,
    maxMileage: Number(100000),
    maxLendAmount: Number(75000),
    minLendAmount: Number(2500),
    maxCustomerAgeAtEnd: null,
    minTerm: Number(12),
    maxTerm: Number(60),
    apr: Number(9.9),
    financeCompany: 'BNP',
    financeCompanyId: BNP,
    tierId: 0,
};

// Note, we could do this with params to restrict filtering
// but, in a way exploding fully, and filtering in the pricing
// logic is cleaner
function getFixedPrimes() {
    const _t = [
        //            apr  minT, maxT, maxAtStart, maxAtEnd, minLen, maxLend
        [BNP, 'BNP', 10.9, 12, 60, 8, 12, 50000, 75000],
        [BNP, 'BNP', 10.9, 12, 60, 8, 12, 30000, 50000],
        [BNP, 'BNP', 11.9, 12, 60, 8, 12, 20000, 30000],
        [BNP, 'BNP', 12.9, 12, 60, 8, 12, 15000, 20000],
        [BNP, 'BNP', 13.9, 12, 60, 8, 12, 10000, 15000],
        [BNP, 'BNP', 14.9, 12, 60, 8, 12, 2500, 10000],

        /* Alphera
        New – 2 years old: 11.9% APR
        2 years old – 5 years old: 12.4% APR
        5+ years old: 12.9% APR
        */

        // The one Alphera rate

        [ALPHERA, 'Alphera', 11.9, 24, 60, 2, 12, 20000, 500000],
        [ALPHERA, 'Alphera', 12.4, 24, 60, 5, 12, 20000, 500000],
        [ALPHERA, 'Alphera', 12.9, 24, 60, 10, 12, 20000, 500000],

        /** V12
        16.9% Min Lend £5k
        15.9% (up to £25k)
        13.9% (£25-£55k)
         */
        [V12, 'V12', 16.9, 24, 60, 10, 15, 5000, 10000],
        [V12, 'V12', 15.9, 24, 60, 10, 15, 10000, 25000],
        [V12, 'V12', 13.9, 24, 60, 10, 15, 25000, 55000],

        [MANNISLAND, 'Mann Island', 13.9, 24, 60, 10, 15, 20000, 200000],
        [MANNISLAND, 'Mann Island', 14.9, 24, 60, 10, 15, 15000, 20000],
        [MANNISLAND, 'Mann Island', 15.9, 24, 60, 10, 15, 10000, 15000],
        [MANNISLAND, 'Mann Island', 16.9, 24, 60, 10, 15, 0, 10000],
    ];

    const result = [];

    for (const t of _t) {
        // Clone template
        const l = { ..._fixedPrimeTemplate };

        l.financeCompanyId = t[0];
        l.financeCompany = t[1];
        l.apr = t[2];
        l.minTerm = t[3];
        l.maxTerm = t[4];
        l.maxVehicleAgeAtStart = t[5];
        l.maxVehicleAgeAtEnd = t[6];
        l.minLendAmount = t[7];
        l.maxLendAmount = t[8];

        result.push(l);
    }

    return result;
};

function isNullOrUndefined(val) {
    if (typeof val === 'undefined' || val === null) {
        return true;
    }
    return false;
};

function getNum(val) {
    if (isNullOrUndefined(val)) {
        return 0;
    }
    return Number(val);
};

// Max getter, but not a classic max() function - this returns Max unless it's empty.
function getMax(val, max_) {
    if (isNullOrUndefined(max_)) {
        return getNum(val);
    }
    return getNum(max_);
};

// Min getter, but not a classic min() function - this returns Min unless it's empty.
function getMin(val, min_) {
    if (isNullOrUndefined(min_)) {
        return getNum(val);
    }
    return Number(min_);
};

// Optional Rounding, may parameterise for each Lender if need to get more accurate
function roundToFiveDecimalPlaces(val) {
    return Math.round(val * 100000.0) / 100000.0;
};

// Determine if "val" is inside min and max, with safe getters for the ranges.
// eslint-disable-next-line no-unused-vars
function insideRange(min_, max_, val_, info_ = 'unknown') {
    const passes = getMin(val_, min_) <= Number(val_) && Number(val_) <= getMax(val_, max_);

    /* if (!passes) {
      console.warn('Outside Range for field', info_, min_, '=>', max_, val_);
    }
    else {
      console.info('INSIDE Range for field', info_, min_, '=>', max_, val_);
    } */
    return passes;
};

// Handy "same" function for comparing strings, defaulting to false for null/undefined either side
function same(st1, st2) {
    if (isNullOrUndefined(st1) || isNullOrUndefined(st2)) {
        return false;
    }
    if (st1.toUpperCase() === st2.toUpperCase()) {
        return true;
    }
    return false;
};

function getPrimeRate(loanAmount, ageInMonths = -1, customer = null, bespokeRates = null, financeCompanyId = null, pcp = false) {
    // 0-5k   11.90%
    // 5-10k  10.90%
    // 10-15k 8.90%
    // 15-25k 8.90%
    // 25-50k 7.90%
    let rates = [
        { rate: 12.9, limit: 0.0 },
        { rate: 11.9, limit: 10000.0 },
        { rate: 11.9, limit: 15000.0 },
        { rate: 10.9, limit: 20000.0 },
        { rate: 9.9, limit: 30000.0 },
        { rate: 9.9, limit: 50000.0 },
        { rate: 8.9, limit: 75000.0 },
    ];

    // Dealer bespoke rates
    if (bespokeRates) {
        if (Array.isArray(bespokeRates) && bespokeRates.length > 0) {
            const rateOverride = bespokeRates.find(r => r.financeCompanyId === financeCompanyId);
            if (rateOverride && rateOverride.rate) {
                return rateOverride.rate
            }
        }
    }

    if (customer) {
        //set to minimum
        if (!customer.creditCheckScore) {
            customer.creditCheckScore = 1;
        }
        let range = null;

        // Affiliate rates
        if (customer.affiliateUserId && ([CkDirectAffiliateId, CTM, CargurusAffiliateId, PistonheadsAffiliateId, CarcraftAffiliateId].includes(customer.affiliateUserId))) {
            range = primeRatesCtMandCkDirect.find(r => customer.creditCheckScore >= r.score);
        }
        else { // non affiliate rates
            range = primeRates.find(r => customer.creditCheckScore >= r.score);
        }

        if (range) {
            rates = range.rates;
        }
    }

    let { rate } = rates[0];

    // eslint-disable-next-line no-restricted-syntax
    for (const r of rates) {
        if (loanAmount >= r.limit) {
            // eslint-disable-next-line prefer-destructuring
            rate = r.rate;
        }
    }

    // Any prime overrides go here - see old Alphera rates commit https://github.com/Carfinance247/pricing/blob/7768be1e258ef1b3b6eafaabf79df928da19dfaa/src/calculator-constants.js#L630-L651

    return rate;
};

function sumPresentValues(values, i) {
    let sum = 0;

    for (let j = 0; j < values.length; j += 1) {
        // eslint-disable-next-line no-restricted-properties
        sum += (values[j]) / Math.pow(1.0 + i, j / 12.0);
    }

    return sum;
};

function calcAPRBisectionMethod(Advances, Instalments, dp = 2) {

    let minimum_i = 0;
    let maximum_i = 1000;
    let i;

    let iterations = 0;
    const max_iterations = 1000; // maximum number of attempts at solving for apr.

    do {
        i = minimum_i + (maximum_i - minimum_i) / 2;

        let total_PVs_for_advances = sumPresentValues(Advances, i);
        let total_PVs_for_instalments = sumPresentValues(Instalments, i);

        if (total_PVs_for_instalments > total_PVs_for_advances) {
            minimum_i = i;
        }
        else {
            maximum_i = i;
        }

        iterations++;
        //Console.WriteLine("{1,4:G} APR guess = {0:P}", i, iterations);

        if (iterations > max_iterations) {
            break;
        }
    }
    while (!(maximum_i - minimum_i < 0.0000001));

    return i.toFixed(dp + 2);
};

function installmentBuilder(monthly, term, first = 0, last = 0) {
    let installments = [];
    installments.push(0);
    for (var i = 0; i < term; i++) {
        if (i == 0) {
            if (first) {
                installments.push(first);
            }
            else {
                installments.push(monthly);
            }
        }
        else {
            if (i == term - 1) {
                if (last) {
                    installments.push(last);
                } else {
                    installments.push(monthly);
                }
            }
            else {
                installments.push(monthly);
            }
        }
    }
    return installments;
};

function calculateEffectiveRate(loanAmount, flat, pcm, term) {
    let guess = flat * 1.83;
    let N = 0;
    let delta = 100;

    // Starter rates - good range - highly likely to be around 1.85
    let r1 = 1.7;
    const r2 = 2.2;

    // 16 stage binary search, escape if delta is small or 16th iteration
    while (N < 16 && delta > 0.005) {
        const g1 = flat * r1;
        const g2 = flat * r2;

        const p1 = calculateMonthlyPayment(loanAmount, g1, term);
        const p2 = calculateMonthlyPayment(loanAmount, g2, term);

        const m1 = p1.monthlyPayment;
        const m2 = p2.monthlyPayment;

        // Refine rate ..
        r1 += (1.0) * (r2 - r1) * (pcm - m1) / (m2 - m1);

        // Delta
        delta = Math.abs(pcm - m1);

        // console.warn("[", N, "]", m1.toFixed(2), pcm, m2.toFixed(2), r1.toFixed(2), r2.toFixed(2), g1.toFixed(2), g2.toFixed(2), p1.totalAmountPayable.toFixed(2));

        guess = g1;
        N += 1;
    }

    return guess;

    // console.log('Broke out of loop for effecive APR as close', N, flat, guess.toFixed(2), pm.toFixed(2), pcm.toFixed(2), term, loanAmount, term, calc);
};

// Who adds fees into the agreements that attract interest
function getLendersPreFees(lender) {
    if (lender === ADVANTAGE) { // advantage
        return 325.0;
    }

    return 0.0;
};

// Who has completion/final fees by lender
function getLendersPostFees(lender) {
    switch (lender) {
        case ADVANTAGE:
            return 200.0;
        case CARFINANCE247:
        case MONEYWAY:
        case STARTLINE:
        case SMF:
        case MARSH:
        case V12:
        case BNP:
        case CLOSE:
        case CREDITAGRICOLE:
        case TANDEM:
        case NORTHRIDGEFINANCE:
            return 10.0;
        case BLUE:
        case MOTONOVO:
        case MANNISLAND:
        case METROBANK:
        case BILLING:
            return 1.0;
        case OODLE:
            return 50.0;
        case ALPHERA:
            return 1.0;
        case ZOPA:
            return 0;
        case AUTOMONEY:
            return 199.0
        case LENDABLE:
            return 25.0;
        case CAMCO:
            return 20.0;
        default:
            break;
    }

    return 0.0;
};

// Calculate the Monthly Payment of loan, at a given APR, over a term, with deposit and fees
function calculateMonthlyPayment(vehiclePrice, apr, term, deposit = 0, prop = null) {

    const truncate = prop ? LENDERS_TRUNCATE_MONTHLY_PAYMENT.find(v => v === prop.financeCompanyId) : false;
    const truncateAndRoundMonthlyPayment = prop ? LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT.find(v => v === prop.financeCompanyId) : false;

    const lendersPreFees = prop ? getLendersPreFees(prop.financeCompanyId) : 0;
    const lendersPostFees = prop ? getLendersPostFees(prop.financeCompanyId) : 0;

    const termAdjust = prop && LENDERS_TERM_ADJUST.find(v => v.financeCompanyId === prop.financeCompanyId && v.hp === true) ? LENDERS_TERM_ADJUST.find(v => v.financeCompanyId === prop.financeCompanyId && v.hp === true).adjust : 0;
    term -= termAdjust;

    if (vehiclePrice && apr && term) {
        const loanAmount = getNum(vehiclePrice) - getNum(deposit);
        if (loanAmount > 0) {
            const monthlyInterestRate = Math.pow((getNum(apr) / 100) + 1, (1 / 12)) - 1;

            let monthlyPayment = 0;

            let pow = Math.pow(monthlyInterestRate + 1, term);

            if (prop && LENDERS_OTP_SPREAD_HP.find(v => v === prop.financeCompanyId)) {
                const mpotratio = (pow - (lendersPostFees / (vehiclePrice - deposit))) / pow;

                const numerator = loanAmount * monthlyInterestRate * mpotratio;
                const denominator = (1 - Math.pow(1 / (1 + monthlyInterestRate), term));

                monthlyPayment = numerator / denominator;
            }
            else {
                const numerator = loanAmount * monthlyInterestRate * pow;
                const denominator = pow - 1;
                monthlyPayment = numerator / denominator
            }
            // Certain lenders do this
            if (truncate) {
                monthlyPayment = (Math.trunc(monthlyPayment * 100.0) / 100.0);
            }

            if (truncateAndRoundMonthlyPayment) {
                monthlyPayment = roundToDecimalPlaces(monthlyPayment, 2);
            }

            const totalAmountPayable = (monthlyPayment * (term)) + getNum(lendersPreFees);
            const finalPayment = getNum(lendersPostFees) > 0.0 ? monthlyPayment + getNum(lendersPostFees) : monthlyPayment;
            const mpxterm = roundToDecimalPlaces(monthlyPayment * term, 2);

            const tot = mpxterm + getNum(lendersPostFees) + getNum(deposit);

            let cost = tot - loanAmount - getNum(deposit) - lendersPostFees;
            cost = roundToDecimalPlaces(cost, 2);

            let monthlyP = (totalAmountPayable) / getNum(term);

            if (prop && LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT.includes(prop.financeCompanyId)) {
                cost += lendersPostFees;
            }

            return {
                monthlyPayment: monthlyP,
                firstMonthlyPayment: monthlyP,
                finalPayment,
                totalAmountPayable: tot,
                apr,
                effectiveRate: apr,
                amountToFinance: loanAmount,
                costOfCredit: cost,
                termDisplay: term,
                lendersPreFees,
                lendersPostFees,
                commissionAmount: -1,
            };
        }
    }
    return null;
};

/** Flexible decimal place rounding for */
function roundToDecimalPlaces(v, places = 2) {
    const scale = 10 ** places;

    if (v) {
        return Math.round(scale * v) / scale;
    }
    return 0.00;
};

function p2(v) {
    if (v) {
        return v.toFixed(2);
    }

    return '####';
};

function nf(v, len) {
    let r = '.';
    if (v && v != null && v != "null") {
        r = "" + v;
    }
    if (r.length > len) {
        r = r.substring(0, len);
    }
    while (r.length < len) {
        r = " " + r;
    }
    return r;
}

/**
 * Generic function to output a quote nicely
 */
function formatQuote(v1) {
    let result =
        `[${nf(v1.rank, 2)}] ${nf(v1.financeCompany, 20)} (${nf(v1.tierId, 3)}) ${nf(p2(v1.effectiveRate), 4)}%` +
        ` ${nf(v1.term, 3)} @ £${nf(p2(v1.monthlyPayment), 7)}} (F: £${nf(p2(v1.firstMonthlyPayment), 7)}}, L: £${nf(p2(v1.finalPayment), 7)}})` +
        `   MinDep: £${nf(p2(v1.minDeposit), 9)}}   TotPay: £${nf(p2(v1.totalAmountPayable), 9)}}   CostCred: £${nf(p2(v1.costOfCredit), 9)}} `;

    return result;
};

function dumpMatrix(v1) {
    if (!Array.isArray(v1.priceMatrix)) {
        console.warn(' [ NO PRICES RETURNED FOR THIS VEHICLE]');
        return;
    }
    let N = 0;
    // eslint-disable-next-line no-restricted-syntax
    //console.log('HP Quote : £', v1.price, v1.deposit );
    for (const vv of v1.priceMatrix) {
        //console.log('HP : ', v1.price, vv.term, 'r', vv.rank, vv.financeCompany, vv.financeCompanyId, vv.tierId, vv.tierName, p2(vv.effectiveRate), p2(vv.monthlyPayment), p2(vv.firstMonthlyPayment), p2(vv.finalPayment), 'dep:', p2(vv.minDeposit), p2(vv.totalAmountPayable), p2(vv.costOfCredit));
        //console.log( '1 -', formatQuote(vv));

        for (const ao of vv.otherOptions) {
            //console.log(' oth   {', N, '} ', ao.term, 'r', ao.rank, ao.financeCompany, ao.financeCompanyId, ao.tierId, ao.tierName, p2(ao.effectiveRate), p2(ao.monthlyPayment), p2(ao.firstMonthlyPayment), p2(ao.finalPayment), 'dep:', p2(ao.minDeposit), p2(ao.totalAmountPayable), p2(ao.costOfCredit));
            //console.log( 'O -', formatQuote(ao));
            N += 1;
        }

        for (const ao of vv.altOptions) {
            //console.log(' alt   [', N, '] ', ao.term, 'r', ao.rank, ao.financeCompany, ao.financeCompanyId, ao.tierId, ao.tierName, p2(ao.effectiveRate), p2(ao.monthlyPayment), p2(ao.firstMonthlyPayment), p2(ao.finalPayment), 'dep:', p2(ao.minDeposit), p2(ao.totalAmountPayable), p2(ao.costOfCredit));
            //console.log( 'A -', formatQuote(ao));
            N += 1;
        }
    }

    if (Array.isArray(v1.pcpMatrix)) {
        for (const vv of v1.pcpMatrix) {
            //console.log('P -', formatQuote(vv));
            // console.log('PCP', vv);
        }

        for (const vv of v1.priceMatrix) {

            for (const ao of vv.otherOptions) {
                //console.log(' oth   {', N, '} ', ao.term, 'r', ao.rank, ao.financeCompany, ao.financeCompanyId, ao.tierId, ao.tierName, p2(ao.effectiveRate), p2(ao.monthlyPayment), p2(ao.firstMonthlyPayment), p2(ao.finalPayment), 'dep:', p2(ao.minDeposit), p2(ao.totalAmountPayable), p2(ao.costOfCredit));
                if (ao.pcp) console.log('po-', formatQuote(ao.pcp));
                N += 1;
            }

            for (const ao of vv.altOptions) {
                //console.log(' alt   [', N, '] ', ao.term, 'r', ao.rank, ao.financeCompany, ao.financeCompanyId, ao.tierId, ao.tierName, p2(ao.effectiveRate), p2(ao.monthlyPayment), p2(ao.firstMonthlyPayment), p2(ao.finalPayment), 'dep:', p2(ao.minDeposit), p2(ao.totalAmountPayable), p2(ao.costOfCredit));
                if (ao.pcp) console.log('pa-', formatQuote(ao.pcp));
                N += 1;
            }
        }

    }
};

// Minimal Load-Ash type object navigation function
const getByPath = (obj, path, defValue = 0) => {
    // If path is not defined or it has false value
    if (!path) return 0;

    //console.log('Looking for path', path, 'in', obj);

    // Check if path is string or array. Regex : ensure that we do not have '.' and brackets.
    // Regex explained: https://regexr.com/58j0k
    const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
    // Find value
    const result = pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj);
    // If found value is undefined return default value; otherwise return the value
    return result === undefined ? defValue : result;
};

/** Generic Final Santity Check for HP and PCP, dealing with multiple tiers */
function vehicleQualifies(prop, vehicle, loanAmount, term, options, deposit = 0, pcp = true) {

    if (!prop.vehicleRuleResults) prop.vehicleRuleResults = [];
    if (!vehicle.cannotPriceReasons) vehicle.cannotPriceReasons = [];

    const annualMileage = options.annualMileage ? options.annualMileage : 8000;

    // Default to the proposal
    let minLoanAmount = prop.minLendAmount;
    let maxLoanAmount = prop.maxLendAmount;
    let maxMileage = ProposalHelper.getPropMaxMileage(prop, vehicle);
    let maxMileageAtTerm = 200000;
    let minAnnualMileage = null;
    let maxAnnualMileage = null;
    let maxAgeAtStart = prop.maxVehicleAgeAtStart;
    let maxAgeAtTerm = ProposalHelper.getPropMaxVehicleAgeAtEnd(prop, vehicle);
    let minTerm = prop.minTerm;
    let maxTerm = prop.maxTerm;
    let minDepositPercent = pcp ? prop.minDepositPcp : prop.minDepositHp;
    let maxDepositPercent = pcp ? prop.maxDepositPcp : prop.maxDepositHp;

    //for cars
    if (prop.maxVehicleAgeAtEnd_HP_Electric > 0 && vehicle.fuel == "Electric/Hybrid") {
        maxAgeAtTerm = prop.maxVehicleAgeAtEnd_HP_Electric;
    }

    //Vans
    if (vehicle.vehicleType == VEHICLE_TYPE_ENUM.VAN) {
        maxAgeAtTerm = prop.maxVanAgeAtEnd
    }

    if (pcp) {

        // defaults for the decision
        minLoanAmount = prop.minLendAmount ? prop.minLendAmount : 2500;
        maxLoanAmount = prop.maxLendAmount ? prop.maxLendAmount : 1000000;
        maxMileage = prop.maxMileage ? prop.maxMileage : 80000;
        maxMileageAtTerm = 200000;
        maxAgeAtTerm = 999; // likely change
        maxAgeAtStart = 999; // likely changed
        minTerm = 24;
        maxTerm = 60;

        // See JIRA : https://247group.atlassian.net/browse/CRM2-2438
        switch (prop.financeCompanyId) {
            case MOTONOVO:
                /*
          Min Lend £3000
          Max Lend - HP - £75k /  PCP - £50k
          Min Term - 36 months
          Max Term  - HP - 60month/ PCP - 48 Months
          Max Age of vehicle - HP - 15 Years @ end / PCP - 5 years @ end
          Max Mileage - HP 130000 / PCP 70000
                */
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 3000.00;
                maxLoanAmount = 50000.00;
                maxMileage = 70000.00;
                minTerm = 36;
                maxTerm = 48;
                maxAgeAtStart = 5;
                break;

            case ALPHERA:
                /*
                Min Lend  - £12_500
                Max Lend - £500k 
                Min Term - 24 months
                Max Term  - 60 months (10% deposit required for 60 month PCP)
                Max Age of vehicle - HP 12 Years @ end / PCP - 10 years @ end 
                Max Mileage - HP - 80K @ start/ PCP - £50K @ start and 150k @ end
                */
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 12500;
                maxLoanAmount = 500000;
                minTerm = 24;
                maxTerm = 60; // Deposit Rule elsewhere
                maxAgeAtTerm = 10;
                maxMileage = 80000;
                maxMileageAtTerm = 150000;
                maxAnnualMileage = 50000;
                break;
            case BNP:
                /*
          Min Lend - £2500
          Max Lend - HP - /  PCP - £75000
          Min Term - 12 months HP/ 24 months PCP
          Max Term  - HP -60 months / PCP - 49 months
          Max Age of vehicle -  8 years @ start / 12 Years @ end / PCP - 5 years @ start / 9 years @ end 
          Max Mileage - HP-100k  / PCP -60k @ start and 100K @ End
                */
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 2500;
                maxLoanAmount = 75000;
                maxTerm = 60;
                minTerm = 24;
                maxAgeAtStart = 5;
                maxAgeAtTerm = 9;
                maxMileage = 60000;
                maxMileageAtTerm = 100000;
                break;
            case CARFINANCE247:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 2500;
                maxLoanAmount = 500000;
                maxTerm = 60;
                minTerm = 24;
                maxAgeAtStart = 5;
                maxAgeAtTerm = 10;
                maxMileage = 80000;
                maxMileageAtTerm = 150000;
                break;
            case MANNISLAND:
                /*
                Min Lend - £2500 / PCP - £6000
                Max Lend - HP- none /  PCP - £89999
                Min Term - 36 months
                Max Term  - HP - 60 months / PCP - 49 months
                Max Age of vehicle - HP - 12 years @ end / PCP - 5 Years @ end
                Max Mileage - HP - 80,000/ PCP - 80K
                */
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 6000.00;
                maxLoanAmount = 89999.00;
                minTerm = 36;
                maxTerm = 49;
                maxAgeAtTerm = 5;
                maxMileage = 80000.00;
                break;
            case CLOSE:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 1000;
                maxLoanAmount = 200000;
                maxMileage = 50000;
                maxMileageAtTerm = null;
                maxAgeAtTerm = null;
                maxAgeAtStart = 5;
                minTerm = 36;
                maxTerm = 49;
                break;
            case ZOPA:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 5000;
                maxLoanAmount = 50000;
                minTerm = 24;
                maxTerm = 48;
                maxMileage = 70000;
                maxAgeAtStart = 5;
                maxAgeAtTerm = null;
                break;
            case CREDITAGRICOLE:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 10000;
                maxLoanAmount = 300000;
                minTerm = 24;
                maxTerm = 49;
                maxMileage = 70000;
                maxAgeAtStart = null;
                maxAgeAtTerm = 9;
                maxMileageAtTerm = 143000;
                minAnnualMileage = 5000;
                maxAnnualMileage = 35000;
                break;
            case V12:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 5000;
                maxLoanAmount = 20000;
                minTerm = 36;
                maxTerm = 48;
                maxMileage = 108000;
                maxAgeAtStart = 5;
                maxAgeAtTerm = 9;
            case NORTHRIDGEFINANCE:
                minLoanAmount = prop.minLendAmountPcp ? prop.minLendAmountPcp : 5000;
                maxLoanAmount = 90000;
                minTerm = 36;
                maxTerm = 49;
                maxMileage = 120000;
                maxMileageAtTerm = 120000
                maxAgeAtStart = 5;
                maxAgeAtTerm = 9;
                break;
            default:
                break;
        }

    } // pcp overrides


    // Out of term
    if (!insideRange(minTerm, maxTerm, term, 'pcp_term')) {
        // console.log('Term failing', minTerm, maxTerm, term, proposal.financeCompany);
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            term,
            resultType: 'FinanceFailRule',
            displayPriority: 1,
            pcp: pcp ? pcp : false,
            message: 'Term ' + term + " months not supported"
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            term,
            pcp,
            reason: "Not available at term"
        })
        return false;
    }

    // Used for mileage at end
    const termInYears = term / 12;

    if (maxMileage && vehicle.mileage > maxMileage) {
        // console.log('Mileage, failing', prop);
        prop.vehicleRuleResults.push({
            id: prop.financeCompanyId,
            vehicleId: vehicle.vehicleId,
            resultType: 'VehicleFailRule',
            displayPriority: 2,
            pcp: pcp ? pcp : false,
            message: 'Vehicle mileage exceeds ' + maxMileage.toLocaleString() + " miles"
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            reason: "Max Mileage"
        })
        return false;
    }

    // Determine mileage at end
    const mileageAtTerm = vehicle.mileage + (termInYears * (annualMileage ? annualMileage : 1));

    if (maxMileageAtTerm && mileageAtTerm > maxMileageAtTerm) {
        // console.log('Age, PCP, failing', prop);
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            term,
            pcp: pcp ? pcp : false,
            resultType: 'FinanceFailRule',
            displayPriority: 1,
            message: 'Vehicle mileage will exceed ' + maxMileageAtTerm.toLocaleString() + " miles at end of " + term + " month agreement"
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            term,
            reason: "Max mileage at term"
        })
        return false;
    }

    if (maxAnnualMileage && annualMileage > maxAnnualMileage) {
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            pcp: pcp ? pcp : false,
            resultType: 'FinanceFailRule',
            displayPriority: 1,
            message: 'Exceeds max annual mileage'
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            reason: "Exceeds max annual mileage"
        })
        return false;
    }

    if (minAnnualMileage && annualMileage && annualMileage < minAnnualMileage) {
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            pcp: pcp ? pcp : false,
            resultType: 'FinanceFailRule',
            displayPriority: 1,
            message: 'Does not meet min annual mileage'
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            reason: "Does not meet min annual mileage"
        })
        return false;
    }

    if (maxDepositPercent && deposit > (vehicle.price * maxDepositPercent)) {
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            pcp: pcp ? pcp : false,
            resultType: 'FinanceFailRule',
            rule: 'DepositRule',
            displayPriority: 3,
            message: 'Deposit + PX is over ' + (maxDepositPercent * 100).toLocaleString() + '% of vehicle price'
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            reason: 'Deposit + PX is over ' + (maxDepositPercent * 100).toLocaleString() + '% of vehicle price'
        })
        return false;
    }

    if (minDepositPercent && deposit < (vehicle.price * minDepositPercent)) {
        prop.vehicleRuleResults.push({
            vehicleId: vehicle.vehicleId,
            pcp: pcp ? pcp : false,
            resultType: 'FinanceFailRule',
            rule: 'DepositRule',
            displayPriority: 3,
            message: 'Deposit + PX is under ' + (minDepositPercent * 100).toLocaleString() + '% of vehicle price'
        })
        vehicle.cannotPriceReasons.push({
            financeCompanyId: prop.financeCompanyId,
            reason: 'Deposit + PX is under ' + (minDepositPercent * 100).toLocaleString() + '% of vehicle price'
        })
        return false;
    }

    // This is global - got to pass this global filter
    if (insideRange(minLoanAmount, maxLoanAmount + 0.001, loanAmount, 'pcp_amount')) {
        const age = vehicleAge(vehicle);

        if (!isNullOrUndefined(maxAgeAtStart) && age > maxAgeAtStart) {
            // console.log('Age, maxAgeAtStart, failing', prop);
            prop.vehicleRuleResults.push({
                id: prop.financeCompanyId,
                vehicleId: vehicle.vehicleId,
                resultType: 'VehicleFailRule',
                pcp: pcp ? pcp : false,
                displayPriority: 3,
                message: 'Vehicle age exceeds ' + (maxAgeAtStart * 12) + " months"
            })
            if (!vehicle.cannotPriceReasons.find(r => r.financeCompanyId === prop.financeCompanyId && r.reason === "Max age at start")) {
                vehicle.cannotPriceReasons.push({
                    financeCompanyId: prop.financeCompanyId,
                    reason: "Max age at start"
                })
            }

            return false;
        }

        maxAgeAtTerm = maxAgeAtTerm > 15 ? maxAgeAtTerm / 12 : maxAgeAtTerm;

        if (isNullOrUndefined(maxAgeAtTerm) || (age + termInYears) <= maxAgeAtTerm) {
            return true;
        }
        else if ((age + termInYears) > maxAgeAtTerm) {
            prop.vehicleRuleResults.push({
                vehicleId: vehicle.vehicleId,
                resultType: 'FinanceFailRule',
                displayPriority: 2,
                pcp: pcp ? pcp : false,
                term,
                message: 'Vehicle age at end of term'
            })
            if (!vehicle.cannotPriceReasons.find(r => r.financeCompanyId === prop.financeCompanyId && r.reason === "Max age at term")) {
                vehicle.cannotPriceReasons.push({
                    financeCompanyId: prop.financeCompanyId,
                    reason: "Max age at term"
                })
            }
            return false;
        }
    }
    else {
        if (loanAmount > maxLoanAmount) {
            prop.vehicleRuleResults.push({
                vehicleId: vehicle.vehicleId,
                resultType: 'FinanceFailRule',
                displayPriority: 1,
                pcp: pcp ? pcp : false,
                message: 'Loan amount exceeds maximum of £' + maxLoanAmount.toLocaleString()
            })
            vehicle.cannotPriceReasons.push({
                financeCompanyId: prop.financeCompanyId,
                reason: "Loan amount exceeds maximum"
            })
        }
        if (loanAmount < minLoanAmount) {
            prop.vehicleRuleResults.push({
                vehicleId: vehicle.vehicleId,
                resultType: 'FinanceFailRule',
                displayPriority: 1,
                pcp: pcp ? pcp : false,
                message: 'Loan amount does not meet minimim of £' + minLoanAmount.toLocaleString()
            })
            vehicle.cannotPriceReasons.push({
                financeCompanyId: prop.financeCompanyId,
                reason: "Loan amount below minimum"
            })
        }
    }
    //console.log('Vehicle Qualifies for PCP, false', prop);
    return false;
};

function isVehiclePcpEligible(vehicle, proposals = null, annualMileage = 8000, deposit = 0, options = {}) {

    try {

        vehicle.price = getNum(vehicle.price);
        vehicle.mileage = getNum(vehicle.mileage);

        if (!proposals || !Array.isArray(proposals) || proposals.length === 0) {
            proposals = [
                mockAlpheraProposal(vehicle.price),
                mockBnpProposal(vehicle.price),
                mockCloseProposal(vehicle.price),
                mockZopaProposal(vehicle.price)
            ]
        }

        const pcpProps = proposals.filter(p => PCP_LENDERS.includes(p.financeCompanyId));

        let pcpEligible = false;

        for (let prop of pcpProps) {

            const {
                extrasInPrice,
                extrasOutPrice
            } = getExtrasPricesForLender(vehicle, vehicle.price - deposit, prop.financeCompanyId, options);

            const actualLoanAmount = getNum(vehicle.price) + getNum(extrasInPrice) + getNum(extrasOutPrice) - getNum(deposit);

            for (let term of [24, 36, 48, 60]) {
                vehicleQualifies(prop, vehicle, actualLoanAmount, term, options, deposit, true) ? pcpEligible = true : null;
            }
        }
        return pcpEligible;
    }
    catch (error) {
        console.error("PRICING ERROR - isVehiclePcpEligible :::", error);
        return false;
    }
}

/**
 * Returns the age in months of a given vehicle using a variety of strategies (year, regYear and dates of registration)
 * the ageInMonths is cached on the vehicle for future calls
 * @param {*} vehicle the vehicle
 * @returns age of the vehicle to a best approximation in months
 */
function vehicleAgeInMonths(vehicle) {
    // Check cached result
    if (vehicle.hasOwnProperty('ageInMonths') && vehicle.ageInMonths > 0) {
        return vehicle.ageInMonths;
    }

    let date = null;

    if (vehicle.hasOwnProperty('registrationDate')) {
        date = vehicle.registrationDate;
    }

    // Just in case
    if (date == null || date === undefined || date === '') {
        if (vehicle.hasOwnProperty('dateOfRegistration')) {
            date = vehicle.dateOfRegistration;
        }
    }

    // Just in case
    if (date == null || date === undefined || date === '') {
        if (vehicle.hasOwnProperty('vehicleDateOfFirstReg')) {
            date = vehicle.vehicleDateOfFirstReg;
        }
    }


    // Ok, got to fallback
    if (date == null || date === undefined || date === '') {
        const { year } = vehicle;

        let yy = getNum(year);

        // Can't process if no vehicle year
        if (yy > 0) {
            if (yy < 100) {
                yy = 2000 + yy; // just in case we've got "regYear" like things going on
            }
        }

        // Make a date up for the start of that year
        date = new Date();
        date.setFullYear(yy);
    }

    // Note - uses moment inside dateLib - which is tolerant of strings, date objects etc
    let ageInMonths = dateLib.getMonthsSince(date);
    if (ageInMonths < 0) {
        ageInMonths = 0;
    }
    vehicle.ageInMonths = ageInMonths;
    // console.log('[Vehicle Age]', ageInMonths);
    return ageInMonths;
};

// Vehicle Age Function
function vehicleAge(vehicle) {
    // delegate to age in months function
    const aim = vehicleAgeInMonths(vehicle);

    return aim / 12;
};


// Utility function
function findBetterEffectiveRates(alternatives, target, financeCompanyId, effectiveRate, term) {
    // eslint-disable-next-line no-restricted-syntax
    for (const s of alternatives) {
        // Only interested if the rate is LESS
        if (s.effectiveRate <= effectiveRate && s.financeCompanyId !== financeCompanyId) {
            const candidate = target.find(x => s.financeCompanyId === x.financeCompanyId);

            if (candidate) {
                if (Math.abs(term - s.term) <= Math.abs(term - candidate.term)) {
                    // Remove current one
                    target = target.filter(x => x.financeCompanyId !== s.financeCompanyId);
                    // Add
                    let c = Object.assign({}, s);
                    c.altOptions = null;
                    target.push(c);
                }
            } else {
                let c = Object.assign({}, s);
                c.altOptions = null;
                target.push(c);
            }
        }
    }
    return target;
};

// Some lenders have rate adjustment rules
function getLendersRateAdjust(lender, term, price, deposit) {
    // if (lender === ADVANTAGE) { // Advantage
    //     if (term > 48 && (price - deposit) > 6000) {
    //         return 1.0;
    //     }
    // }
    if (lender === AUTOMONEY) {
        if (term > 48 && (price - deposit) < 10000) {
            return 0;
        }
    }
    return 0.0;
};

// Does this loan qualify for a PCP quote
function hpQualified(vehicle, loanAmount, term) {
    // Consts for the decision
    const MIN_LOAN_AMOUNT_FOR_HP = 2499.99;
    const MAX_MILEAGE = 120000.00;
    const MAX_AGE_AT_TERM = 15;

    if (vehicle.mileage > MAX_MILEAGE) {
        return false;
    }

    if (loanAmount > MIN_LOAN_AMOUNT_FOR_HP) {
        const termInYears = term / 12;
        const age = vehicleAge(vehicle);

        if ((age + termInYears) <= MAX_AGE_AT_TERM) {
            return true;
        }
    }
    return false;
};

// Does this loan qualify for a PCP quote - simple form for members
function pcpQualified(vehicle, loanAmount, term) {
    // Consts for the decision
    const MIN_LOAN_AMOUNT_FOR_PCP = 5999.99;
    const MAX_MILEAGE = 80000.00;
    const MAX_AGE_AT_TERM = 10;
    const MAX_AGE_AT_START = 5;

    if (term < 24) {
        return false;
    }

    if (vehicle.mileage > MAX_MILEAGE) {
        return false;
    }

    if (loanAmount > MIN_LOAN_AMOUNT_FOR_PCP) {
        const termInYears = term / 12;
        const age = vehicleAge(vehicle);

        if (age > MAX_AGE_AT_START) {
            return false;
        }

        if ((age + termInYears) <= MAX_AGE_AT_TERM) {
            return true;
        }
    }
    return false;
};

// Take a set of quotes and collapse if there is more than one quote per lender
function collapse(quotes) {
    // Form set of lenders
    const map = new Map();

    for (const q of quotes) {
        if (!map.has(q.financeCompanyId)) {
            map.set(q.financeCompanyId, []);
        }

        // Put in
        map.get(q.financeCompanyId).push(q);
    }

    const collapsed = [];

    // Now iterate and sort
    map.forEach((quotes, financeCompanyId, map) => {

        /*console.log('PRE SORT');
        for( var q of quotes ) {
          console.log(formatQuote(q));
        }*/
        // Sort the value
        if (quotes.length > 0) {
            quotes.sort((a, b) => {
                if (a.minDeposit != b.minDeposit) {
                    return a.minDeposit - b.minDeposit;
                }
                return a.effectiveRate - b.effectiveRate;
            });
        }

        /*console.log('POST SORT');
        for( var q of quotes ) {
          console.log(formatQuote(q));
        }*/

        collapsed.push(quotes[0]);
    });

    // Finally, show all.
    return collapsed;
};

/**
 * Filter for proposals that have complex rejection structures
 * @param {*} p
 * @returns
 */
function isntDeclined(p) {
    if (!p.hasPassedCustomerRules && p.customerRuleResults) {
        for (const r of p.customerRuleResults) {
            // Customer failed OUR RULES but was still Accepted by lender = valid
            if (r.resultType == 'FixedDecline' && p.loanProposalStatus != 'Accepted') {
                return false;
            }
        }
    }
    if (p.loanProposalStatus == 'Declined' ||
        p.loanProposalStatus == 'Processing' ||
        p.loanProposalStatus == 'FailedSendRules' ||
        p.loanProposalStatus == 'MoreInfo' ||
        p.loanProposalStatus == 'ManualProcessing') {
        return false;
    }
    return true;
};

module.exports = {
    LTV_BASELINES,
    LTVS,
    getMaxLTV,
    vehicleValid,
    isVehiclePcpEligible,
    dealerValid,
    calculateFutureValue,
    supportsPCP,
    pcpQualified,
    hpQualified,
    getFixedPrimes,
    getExtrasPricesForLender,
    same,
    insideRange,
    getMin,
    getMax,
    getNum,
    dp2: roundToDecimalPlaces,
    isNullOrUndefined,
    isntDeclined,
    getPrimeRate,
    getLendersRateAdjust,
    calcAPRBisectionMethod,
    installmentBuilder,
    calculateEffectiveRate,
    getLendersPreFees,
    getLendersPostFees,
    calculateMonthlyPayment,
    p: roundToFiveDecimalPlaces,
    dumpMatrix,
    getByPath,
    vehicleQualifies,
    vehicleAgeInMonths,
    vehicleAge,
    findBetterEffectiveRates,
    getWarrantyPrice,
    getPaintPrice,
    getCosmeticRepairPrice,
    collapse,
    p2, nf,
    DEFAULT_TERM,
    MONEYBARN,
    ADVANTAGE,
    LENDABLE,
    CARFINANCE247,
    ALPHERA,
    SMF,
    STARTLINE,
    METROBANK,
    M247,
    OODLE,
    MARSH,
    MONEYWAY,
    BILLING,
    RATESETTER,
    BNP,
    CLOSE,
    MANNISLAND,
    MOTONOVO,
    V12,
    BLUE,
    AUTOMONEY,
    TANDEM,
    ZOPA,
    CREDITAGRICOLE,
    CAMCO,
    PCP_LENDERS,
    GLASSES_EXCLUDED_LENDERS,
    NORTHRIDGEFINANCE,
    LENDERS_TERM_ADJUST,
    LENDERS_FUNDING_WARRANTY,
    LENDERS_FUNDING_PAINT,
    LENDERS_FUNDING_COSMETIC_REPAIR,
    LENDERS_NO_WARRANTY,
    LENDERS_NO_PAINT,
    LENDERS_NO_COSMETIC_REPAIR,
    LENDERS_TRUNCATE_AND_ROUND_MONTHLY_PAYMENT,
    LENDERS_TRUNCATE_MONTHLY_PAYMENT,
    LENDERS_INCLUDE_POST_FEES_IN_COST_OF_CREDIT,
    LENDERS_EXCLUDE_POST_FEES_FROM_COST_OF_CREDIT_PCP,
    LENDERS_EXCLUDE_DEPOSIT_FROM_TOTAL_AMOUNT_PAYABLE,
    LENDERS_NO_MONTHLY_PAYMENT_ROUNDING,
    LENDERS_EXCLUDE_CHARGES_FROM_COST_OF_CREDIT,
    FLAT_RATE_CALC_ROUNDING,
    WARRANTY_PRICES,
    PAINT_PRICES,
    COSMETIC_REPAIR_PRICES
};